import { render, staticRenderFns } from "./VehiculesCard.vue?vue&type=template&id=13869e83&"
import script from "./VehiculesCard.vue?vue&type=script&lang=js&"
export * from "./VehiculesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13869e83')) {
      api.createRecord('13869e83', component.options)
    } else {
      api.reload('13869e83', component.options)
    }
    module.hot.accept("./VehiculesCard.vue?vue&type=template&id=13869e83&", function () {
      api.rerender('13869e83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/transports/components/VehiculesCard.vue"
export default component.exports